import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { getQuickLinks } from '../../lib/api';
import { updateQuickLinks } from '../../redux/quicklinkSlice';
import { MEDIA_ORIGIN } from "../../utils/Environment";

const QuickLinks = () => {
    const history = useHistory();
    const { quicklinks } = useSelector((state) => state.quicklinks);
    const dispatch = useDispatch();

    const quicklinksendRequest = useCallback(() => {
        getQuickLinks()
            .then((response) => {
                if(response) {
                    dispatch(updateQuickLinks(response.slice(0,2)));
                }                
            })
            .catch((error) => {
                console.log(error);
            });
    }, [dispatch]);
    
    useEffect(() => {
        if (quicklinks === null || quicklinks.length === 0) {
            quicklinksendRequest();
        }        
    }, [quicklinksendRequest, quicklinks]);    


    const handleResourceDetail = (value) => {        
        history.push('/appdetail'+value);   
    } 

    const goToRegister = () => {
        history.push('/register')
    }

    return (
    <section className="section introSection">
    <div className="px-5 sm:px-5 md:px-5 lg:px-14 pt-5 sm:pt-5 md:pt-5 lg:pt-10">
        <div className="cards flex gap-4 lg:gap-6 items-stretch *:basis-[300px] md:*:basis-[350px] lg:*:basis-1/3  flex-nowrap *:shrink-0 lg:*:shrink overflow-x-auto pb-[2px]">

        {quicklinks && quicklinks.map((details) =>
            <div className={`card rounded-lg overflow-hidden relative`} key={details.slug_url}>
                <img src={`${MEDIA_ORIGIN}${details.image}`} alt='quickLinks' className='absolute object-cover size-full'/>
                <div className="cardContent eyeMastersCardOverlay p-3 sm:p-6 h-full relative">
                    <div className="flex flex-col gap-5 sm:gap-11 h-full">
                        <div className="flex flex-col gap-3 sm:gap-4 grow">
                            <h3 className="appTitle text-white text-lg leading-4 sm:text-2xl barlowBold sm:leading-6 capitalize tracking-[-0.06px]">{details.resource_title}</h3>
                            <p className="appDesc text-sm sm:text-[18px] leading-5 sm:leading-6 tracking-[-0.25px] text-white font-medium max-w-full sm:max-w-full md:max-w-[75%]">{details.description}</p>
                        </div>
                        <button className="moreBtn button text-white text-sm sm:text-base leading-4 sm:leading-5 font-medium rounded-lg border border-white px-3 py-[6px] sm:px-5 sm:py-[10px] inline-block w-fit cursor-pointer hover:bg-primaryBlue"  onClick={() => handleResourceDetail(details.slug_url)}>More</button>
                    </div>
                </div>
            </div>
        )}
        <div className="card rounded-lg cursor-pointer shadow-cardShadow bg-[#F5F9FD]" onClick={goToRegister}>
            <div className="cardContent  bg-[url('../../assets/images/Register.svg')] bg-no-repeat bg-auto bg-center rounded-lg bg-40 h-full"></div>
        </div>
        </div>
    </div>
    </section>
    )
}

export default QuickLinks;
